import iconReset from "../../../../assets/icon_reset.svg";

const IntroButton = ({ children, onClick }) => {
  return (
    <button
      className="fixed left-3.5 w-16 h-16 bottom-[5rem] bg-white shadow rounded-[24px] flex flex-col items-center justify-center gap-1 bg"
      onClick={onClick}
    >
      <span>
        <img src={iconReset} alt="" />
      </span>
      <span className="text-[0.68rem] font-semibold text-neutral-700">
        {children}
      </span>
    </button>
  );
};

export default IntroButton;
